import React, { PropTypes } from "react";
import { Field, FieldArray, reduxForm } from "redux-form";

import {
  CheckboxGroup,
  CheckboxInput,
  FileInput,
  RadioGroup,
  SelectInput,
  TextInput,
} from "../common/form";

import validationUtils from "../../utils/ValidationUtils";
import { EXAMPLE_FORM_VALIDATION_RULES } from "./ExampleFormValidationRules";

const ArrayTest = (prop) => {
  return (
    <div>
      {prop.fields.map((obj, index) => {
        return (
          <div key={index}>
            <Field
              id={`${obj}.aaa`}
              name={`${obj}.aaa`}
              type="text"
              component={TextInput}
              label="Array test"
            />
            <Field
              id={`${obj}.bbb`}
              name={`${obj}.bbb`}
              type="text"
              component={TextInput}
              label="Array test"
            />
          </div>
        );
      })}
    </div>
  );
};

const ExampleForm = (props) => {
  const { handleSubmit } = props;
  return (
    <div>
      <h2>Example Form</h2>
      <form onSubmit={handleSubmit}>
        <Field
          id="textInput"
          name="textInput"
          type="text"
          component={TextInput}
          label="Text Input:"
        />
        <Field
          id="textArea"
          name="textArea"
          type="textarea"
          component={TextInput}
          componentClass="textarea"
          label="Text Area:"
        />
        <Field
          id="selectInput"
          name="selectInput"
          component={SelectInput}
          options={[
            { value: "", text: " " },
            { value: "0", text: "Zero" },
            { value: "1", text: "One" },
          ]}
          label="Select Input:"
        />
        <Field
          id="radioGroup"
          name="radioGroup"
          component={RadioGroup}
          radios={[
            { value: 0, text: "Zero" },
            { value: 1, text: "One" },
          ]}
          label="Radio Group:"
        />
        <Field
          id="checkboxGroup"
          name="checkboxGroup"
          component={CheckboxGroup}
          checkboxes={[
            { value: "Zero", text: "Zero" },
            { value: "One", text: "One" },
          ]}
          label="Checkbox Group:"
        />
        <Field
          id="checkboxInput"
          name="checkboxInput"
          component={CheckboxInput}
          checkbox={{ value: "breg", text: "" }}
          label="Checkbox Input:"
        />
        <Field
          id="fileInput"
          name="fileInput"
          component={FileInput}
          label="File Input:"
          dropzoneLabel="Drop the files you want to upload here"
        />
        <FieldArray name="names" component={ArrayTest} />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

ExampleForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

// Decorate the form component
export default reduxForm({
  form: "example", // a unique identifier for this form
  validate: (values) =>
    validationUtils.validate(values, EXAMPLE_FORM_VALIDATION_RULES), // <--- validation function given to redux-form
})(ExampleForm);



// WEBPACK FOOTER //
// ./src/components/example/ExampleForm.js